var React = require('react');

function HeroLinkArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m11.5274 1.5c0-.567419-.46-1.027403-1.0274-1.027403h-9.24662c-.567421 0-1.027405.459984-1.027405 1.027403 0 .56742.459984 1.0274 1.027405 1.0274h8.21922v8.2192c0 .5674.45998 1.0274 1.0274 1.0274.5674 0 1.0274-.46 1.0274-1.0274zm-9.80092 10.2265 9.50002-9.50002-1.45298-1.452963-9.500003 9.499983z","fill":"#30353f"}));
}

HeroLinkArrow.defaultProps = {"fill":"none","height":"12","viewBox":"0 0 12 12","width":"12"};

module.exports = HeroLinkArrow;

HeroLinkArrow.default = HeroLinkArrow;
